
import React from 'react';

export const MapPinIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    location_on
  </span>
);